export default function MobileCallBar() {
  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-zinc-950/95 backdrop-blur-md border-t border-red-600/30 p-2.5 shadow-[0_-10px_25px_rgba(0,0,0,0.5)]">
      <div className="flex items-center gap-2">
        <a
          href="tel:+4570700800"
          className="flex-1 flex items-center justify-center gap-2.5 py-3 px-4 bg-red-600 active:bg-red-700 text-white font-bold text-base rounded shadow-lg transition-transform active:scale-[0.98]"
        >
          <span className="relative flex h-3 w-3">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
            <span className="relative inline-flex rounded-full h-3 w-3 bg-white"></span>
          </span>
          <i className="fa-solid fa-phone text-lg" aria-hidden="true" />
          <span className="tracking-wide">RING VAGTCENTRAL 24/7</span>
        </a>
      </div>
    </div>
  );
}
